export const ItemTypes = {
  ROW: "row",
  COLUMN: "column",
}

export const CONFIRM_TRANSITION_IDS = [
    "cancel",
    "close",
    "deactivate",
    "reinstate",
    "reject",
    "remove",
    "remove",
    "retest",
    "retract",
    "unassign"
]
